import {map} from 'lodash'
const LOAD = 'server-sts/clients/LOAD';
const LOAD_SUCCESS = 'server-sts/clients/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/clients/LOAD_FAIL';
const EDIT_START = 'server-sts/clients/EDIT_START';
const EDIT_STOP = 'server-sts/clients/EDIT_STOP';
const SAVE = 'server-sts/clients/SAVE';
const SAVE_SUCCESS = 'server-sts/clients/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/clients/SAVE_FAIL';
const CREATE = 'server-sts/clients/CREATE';
const CREATE_SUCCESS = 'server-sts/clients/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/clients/CREATE_FAIL';
const SEND_CREDENTIALS = 'server-sts/clients/SEND_CREDENTIALS';
const SEND_CREDENTIALS_SUCCESS = 'server-sts/clients/SEND_CREDENTIALS_SUCCESS';
const SEND_CREDENTIALS_FAIL = 'server-sts/clients/SEND_CREDENTIALS_FAIL';

const SEND_COM_CREDENTIALS = 'server-sts/clients/SEND_COM_CREDENTIALS';
const SEND_COM_CREDENTIALS_SUCCESS = 'server-sts/clients/SEND_COM_CREDENTIALS_SUCCESS';
const SEND_COM_CREDENTIALS_FAIL = 'server-sts/clients/SEND_COM_CREDENTIALS_FAIL';


const RESET_CREDENTIAL = 'server-sts/clients/RESET_CREDENTIAL';

const CONSULT = 'server-sts/clients/CONSULT';

const CREATE_COM_CLIENT = 'server-sts/clients/CREATE_COM_CLIENT';
const CREATE_COM_CLIENT_SUCCESS = 'server-sts/clients/CREATE_COM_CLIENT_SUCCESS';
const CREATE_COM_CLIENT_FAIL = 'server-sts/clients/CREATE_COM_CLIENT_FAIL';


const LOAD_COM_CLIENTS            = 'server-sts/clients/LOAD_COM_CLIENTS';
const LOAD_COM_CLIENTS_SUCCESS    = 'server-sts/clients/LOAD_COM_CLIENTS_SUCCESS';
const LOAD_COM_CLIENTS_FAIL       = 'server-sts/clients/LOAD_COM_CLIENTS_FAIL';

const COM_UPDATE_CLIENT            = 'server-sts/clients/COM_UPDATE_CLIENT';
const COM_UPDATE_CLIENT_SUCCESS    = 'server-sts/clients/COM_UPDATE_CLIENT_SUCCESS';
const COM_UPDATE_CLIENT_FAIL       = 'server-sts/clients/COM_UPDATE_CLIENT_FAIL';


const LOAD_COMMERCIALS             = 'server-sts/clients/LOAD_COMMERCIALS';
const LOAD_COMMERCIALS_SUCCESS    = 'server-sts/clients/LOAD_COMMERCIALS_SUCCESS';
const LOAD_COMMERCIALS_FAIL       = 'server-sts/clients/LOAD_COMMERCIALS_FAIL';


const SEND_VALIDATION_EMAIL            = 'server-sts/clients/SEND_VALIDATION_EMAIL';
const SEND_VALIDATION_EMAIL_SUCCESS    = 'server-sts/clients/SEND_VALIDATION_EMAIL_SUCCESS';
const SEND_VALIDATION_EMAIL_FAIL       = 'server-sts/clients/SEND_VALIDATION_EMAIL_FAIL';

const CHECK_VALIDATION_TOKEN            = 'server-sts/clients/CHECK_VALIDATION_TOKEN';
const CHECK_VALIDATION_TOKEN_SUCCESS    = 'server-sts/clients/CHECK_VALIDATION_TOKEN_SUCCESS';
const CHECK_VALIDATION_TOKEN_FAIL      = 'server-sts/clients/CHECK_VALIDATION_TOKEN_FAIL';



const CREATE_COMMERCIAL = 'server-sts/clients/CREATE_COMMERCIAL';
const CREATE_COMMERCIAL_SUCCESS = 'server-sts/clients/CREATE_COMMERCIAL_SUCCESS';
const CREATE_COMMERCIAL_FAIL = 'server-sts/clients/CREATE_COMMERCIAL_FAIL';

const COMMERCIAL_UPDATE           = 'server-sts/clients/COMMERCIAL_UPDATE';
const COMMERCIAL_UPDATE_SUCCESS    = 'server-sts/clients/COMMERCIAL_UPDATE_SUCCESS';
const COMMERCIAL_UPDATE_FAIL       = 'server-sts/clients/COMMERCIAL_UPDATE_FAIL';






const initialState = {
  loaded: false,
  loading: false,
  created: false,
  clientCreatedError:false,
  editing: {},
  saveError: {},
  sending: {},  
  commercials:[],
  loading_coms:false,
  editMode:false,
  com_client_create_loading:false,
  com_client_create_fail:false,
  com_client_create_success:false,
  
  
  commercialUpdateLoading    :false,
  commercialUpdateFail       :false,
  commercialUpdateSuccess    :false,
  commercialCreateLoading    :false,
  commercialCreateSuccess    :false,
  commercialCreateFail       :false,
  
  com_client_create_fail_msg:'',
  
  checkTokenErrorMsg:'',
  checkTokenSuccessMsg:'',
  checkTokenSuccess:false,
  checkTokenError:false,
  
};





export default function reducer(state = initialState, action = {}) {
  switch (action.type) { 
  
    case CREATE_COMMERCIAL :
      return {
        ...state,
        commercialCreateLoading     :true,
        commercialCreateSuccess     :false,
        commercialCreateFail        :false,
      }
  
    case CREATE_COMMERCIAL_SUCCESS :
      return {
        ...state,
        commercialCreateLoading     :false,
        commercialCreateSuccess     :true,
      }  
      
    case CREATE_COMMERCIAL_FAIL :
      return {
        ...state,
        commercialClientCreateLoading     :false,
        commercialClientCreateFail        :true,
      }
      
    case COMMERCIAL_UPDATE :
      return {
        ...state,
        commercialUpdateLoading   :true,
        commercialUpdateFail      :false,
        commercialUpdateSuccess   :false,
      }
  
    case COMMERCIAL_UPDATE_SUCCESS :
      return {
        ...state,
        commercialUpdateLoading:false,
        commercialUpdateSuccess:true,
      }  
      
    case COMMERCIAL_UPDATE_FAIL :
      return {
        ...state,
        commercialUpdateLoading:false,
        commercialUpdateFail:true,
      }     
  
    case CREATE_COM_CLIENT :
      return {
        ...state,
        com_client_create_loading:true,
        com_client_create_fail:false,
        com_client_create_success:false,
        com_client_create_fail_msg:'',
      }
  
    case CREATE_COM_CLIENT_SUCCESS :
      return {
        ...state,
        com_client_create_loading:false,
        com_client_create_success:true,
        com_client_create_fail_msg:'',
      }  
      
    case CREATE_COM_CLIENT_FAIL :
      
      
      
      return {
        ...state,
        com_client_create_loading:false,
        com_client_create_fail:true,
        com_client_create_fail_msg:action.error,
      } 
  
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };
      
    case LOAD_COM_CLIENTS:
      return {
        ...state,
        loading: true
      };
    case LOAD_COM_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        comClients: action.result,
        error: null
      };
    case LOAD_COM_CLIENTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        comClients: null,
        error: action.error
      };      

    case SEND_CREDENTIALS:
      return {
        ...state,
        loaded: false,
        sendCredentialsLoading: true,
        sending: {
        	...state.sending,
        	[action.id]: {loading:true, loaded:false}
        }
      };
    case SEND_CREDENTIALS_SUCCESS:
      return {
        ...state,
        loaded: true,
        error: null,
        sendCredentialError:null,
        sendCredentialsLoading: false,
        sending: {
          ...state.sending,
          [action.id]: {loading:false, loaded:true}
        }

      };
    case SEND_CREDENTIALS_FAIL:
      return {
        ...state,
        sendCredentialsLoading: false,
        loaded: false,
        sendCredentialError: action.error,
        sending: {
          ...state.sending,
          [action.id]: {loading:false, loaded:false}
        }
      };
      
      
      
    case SEND_COM_CREDENTIALS:
      return {
        ...state,
        loaded: false,
        sendCredentialsLoading: true,
        sending: {
          ...state.sending,
          [action.id]: {loading:true, loaded:false}
        }
      };
    case SEND_COM_CREDENTIALS_SUCCESS:
      return {
        ...state,
        loaded: true,
        error: null,
        sendCredentialError:null,
        sendCredentialsLoading: false,
        sending: {
          ...state.sending,
          [action.id]: {loading:false, loaded:true}
        }

      };
    case SEND_COM_CREDENTIALS_FAIL:
      return {
        ...state,
        sendCredentialsLoading: false,
        loaded: false,
        sendCredentialError: action.error,
        sending: {
          ...state.sending,
          [action.id]: {loading:false, loaded:false}
        }
      };
      
    case RESET_CREDENTIAL:
      
      return {
        ...state,
        sending: {
          ...state.sending,
          [action.id]: {loading:false, loaded:false}
        }
      };
      
      
      
    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        },
        
        editMode:true,
      };
    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        editMode:false,
        comUpdateSuccess:false,
        comUpdateError:false,
        sendingValidationSuccess:false,
        sendingValidationError:false,
        
      };

    case CONSULT:
    	return {
	      ...state,
	      consulted:action.client
	    };

    case CREATE:
      return {
    		...state,
    		loading:true
    	};

    case CREATE_SUCCESS:
    	return {
				...state,
				created:true,
				loading:false,
				clientCreatedError:false,
			};

    case CREATE_FAIL:
    	return {
				...state,
				created:false,
				loading:false,
				clientCreatedError:action.error,
			};

    case SAVE:
      return state;

    case SAVE_SUCCESS:
      var data = [...state.data];
      return {
        ...state,
        data: action.result,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.id]: null
        }
      };

    case SAVE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        }
      } : state ;  
      
      
      
    case COM_UPDATE_CLIENT:
      return {
        ...state,
        comUpdateSuccess:false,
        comUpdateError:false,
      }

    

    case COM_UPDATE_CLIENT_SUCCESS:
      //var data = [...state.data];
      return {
        ...state,
        //data: action.result,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.id]: null
        },
        comUpdateSuccess:true,
        
      };

    case COM_UPDATE_CLIENT_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        },
        comUpdateError:true,
      } : state
      
      
      
    case LOAD_COMMERCIALS         :
      return {
        ...state,
        loading_coms: true,
        load_coms_error: false,
        load_coms_success:false,
      };
    case LOAD_COMMERCIALS_SUCCESS :
      return {
        ...state,
        loading_coms: false,
        load_coms_error: false,
        load_coms_success:true,
        commercials: action.result,
      };
      
    case LOAD_COMMERCIALS_FAIL    :
      return {
        ...state,
        loading_coms: false,
        load_coms_error: true,
        load_coms_success:false,
        commercials:[],
      };
            
      
    case SEND_VALIDATION_EMAIL :
      return {
        ...state,
        sendingValidation: true,
        sendingValidationSuccess:false,
        sendingValidationError:false
      };
    case SEND_VALIDATION_EMAIL_SUCCESS :
      return {
        ...state,
        sendingValidation: false,
        sendingValidationSuccess:true
      };
      
    case SEND_VALIDATION_EMAIL_FAIL    :
      return {
        ...state,
        sendingValidation: false,
        sendingValidationError:true
      };
      
      
      
    case CHECK_VALIDATION_TOKEN :
      return {
        ...state,
        checkingToken:true,
        checkTokenSuccess:false,
        checkTokenError:false,
      };
      
      
    case CHECK_VALIDATION_TOKEN_SUCCESS :
      return {
        ...state,
        checkTokenSuccess:true,
        checkTokenSuccessMsg:'Votre compte est validé, vous pouvez vous connecter'
      };

      
    case CHECK_VALIDATION_TOKEN_FAIL    :
      return {
        ...state,
        checkTokenError:true,
        checkTokenErrorMsg: (typeof action.error === 'string' ? action.error : (action.error && action.error.error) || 'Une erreur est survenue')
        
      };
      
    case 'RESET_COM_FORM' :
      return {
        ...state,
        commercialUpdateLoading    :false,
        commercialUpdateFail       :false,
        commercialUpdateSuccess    :false,
        commercialCreateLoading    :false,
        commercialCreateSuccess    :false,
        commercialCreateFail       :false,
        
        com_client_create_loading  :false,
        com_client_create_fail     :false,
        com_client_create_success  :false,
        sendingValidationSuccess   :false,
        sendingValidation          :false, 
        sendingValidationError     :false,
        
      }

      
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.clients && globalState.clients.loaded;
}


export function createClient(values) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (client) => client.post('/client/create', {
      data: {
      	...values
      }
    })
  };
}


export function createCommercial(values) {
  return {
    types: [CREATE_COMMERCIAL, CREATE_COMMERCIAL_SUCCESS, CREATE_COMMERCIAL_FAIL],
    promise: (client) => client.post('/client/createCom', {
      data: {
        ...values
      }
    })
  };
}


export function updateCommercial(values) {
  return {
    types: [UPDATE_COMMERCIAL, UPDATE_COMMERCIAL_SUCCESS, UPDATE_COMMERCIAL_FAIL],
    promise: (client) => client.post('/client/updateCom', {
      data: {
        ...values
      }
    })
  };
}



export function comCreateClient(values) {
  return {
    types: [CREATE_COM_CLIENT, CREATE_COM_CLIENT_SUCCESS, CREATE_COM_CLIENT_FAIL],
    promise: (client) => client.post('/client/comCreateClient', {
      data: {
        values
      }
    })
  };
}

export function loadCOMClients(values=null) {
  return {
    types: [LOAD_COM_CLIENTS, LOAD_COM_CLIENTS_SUCCESS, LOAD_COM_CLIENTS_FAIL],
    
    promise: (client) => client.post('/client/loadCOMClients', {
      data: {...values}
    })
  };
}

export function loadCOMSupervisors(values=null) {
  return {
    types: [LOAD_COM_CLIENTS, LOAD_COM_CLIENTS_SUCCESS, LOAD_COM_CLIENTS_FAIL],
    
    promise: (client) => client.post('/client/loadCOMSupervisors', {
      data: {...values}
    })
  };
}


export function sendValidationEmail(values=null, client) {
  return {
    types: [SEND_VALIDATION_EMAIL, SEND_VALIDATION_EMAIL_SUCCESS, SEND_VALIDATION_EMAIL_FAIL],
    
    promise: (client) => client.post('/client/sendValidationEmail', {
      data: {values, client}
    })
  };
}





export function load() {
  return {
    promise: (client) => client.post('/client/load'),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}

export function loadCommercials() {
  return {
    promise: (client) => client.post('/commercial/load'),
    types: [LOAD_COMMERCIALS, LOAD_COMMERCIALS_SUCCESS, LOAD_COMMERCIALS_FAIL]
  };
}


export function save(values) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (client) => client.post('/client/update', {
      data: {...values}
    })
  }; 
}


export function comUpdateClient(values, client, sendDiff, dirtyFields, commercial, modules) {
  
  return {
    types: [COM_UPDATE_CLIENT, COM_UPDATE_CLIENT_SUCCESS, COM_UPDATE_CLIENT_FAIL],
    promise: (client2) => client2.post('/client/comUpdateClient', {
      data: {values, client, sendDiff, dirtyFields, commercial, modules}
    })
  };
}

export function deleteClient(username) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: (client) => client.post('/client/deleteClient', {
      data: {username}
    })
  };
}

export function sendCredentials(data) {
	var id = data.id;
  return {
    types: [SEND_CREDENTIALS, SEND_CREDENTIALS_SUCCESS, SEND_CREDENTIALS_FAIL],
    promise: (client) => client.post('/client/sendCredentials', {
      data: {client:data}
    }), id
  };
}


export function sendCOMCredentials(data) {
  var id = data.id;
  return {
    types: [SEND_COM_CREDENTIALS, SEND_COM_CREDENTIALS_SUCCESS, SEND_COM_CREDENTIALS_FAIL],
    promise: (client) => client.post('/client/sendCOMCredentials', {
      data: {client:data}
    }), id
  };
}


export function resetCredentials(id) {
  return {
    type: RESET_CREDENTIAL, id
  };
}


export function resetComForm() {
  return { 
    type: 'RESET_COM_FORM', 
    
  };
}



export function editStart(id) {
  return { 
    type: EDIT_START, 
    id,
    comUpdateSuccess:false,
    comUpdateError:false
  };
}

export function editStop(id) {
  return {
    type: EDIT_STOP, 
    id,
    comUpdateSuccess:false,
    comUpdateError:false,
  };
}

export function consultClient(client) {
  return { type: CONSULT, client };
}



export function checkValidationToken(token) {
  
  return {
    types: [CHECK_VALIDATION_TOKEN, CHECK_VALIDATION_TOKEN_SUCCESS, CHECK_VALIDATION_TOKEN_FAIL],
    promise: (client) => client.post('/client/checkValidationToken', {
      data: {token}
    })
  };
  
}

